module.exports = __webpack_public_path__ + "media/images/icons/flags/lang-en-b885d34bcc0795549b7b5251acdc3e94.svg";